var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerplexity = function SvgPerplexity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "m7.279 3.667 4.746 4.372V3.676h.924v4.382l4.767-4.392v4.985h1.957v7.191h-1.951v4.44l-4.773-4.194v4.241h-.924v-4.172l-4.74 4.175v-4.49H5.326v-7.19H7.28V3.667Zm4.05 5.898H6.25v5.365h1.032v-1.692l4.045-3.673Zm-3.12 4.078v4.654l3.816-3.362v-4.759l-3.817 3.467Zm4.766 1.248 3.823 3.358v-2.406h-.005v-2.205l-3.818-3.466zm4.747.04h1.027V9.564h-5.04l4.013 3.635v1.73Zm-.93-6.279V5.766L13.66 8.652zm-5.456 0L8.203 5.766v2.886z"
  })));
};
export default SvgPerplexity;